import { useAuth } from '../../lib/auth';
import { voitMontants } from '../../lib/permissions';
import { useEffect, useState } from 'react';
import { fetchCompteTiers } from '../../lib/dataProvider';
import { fmt } from '../shared/badges';

// Information séparée du droit d'huile : ne bloque pas la remise de sa propriété.
export const SituationClientRetrait = ({ tiersId }) => {
  const {user} = useAuth();
  const autorise = voitMontants(user?.role);
  const [etat, setEtat] = useState(null);
  const [revision, setRevision] = useState(0);
  useEffect(() => {
    let actif = true;
    setEtat(null);
    if (autorise && tiersId) fetchCompteTiers(tiersId).then(compte => {
      if (actif) setEtat({tiersId, solde: compte.solde});
    }).catch(() => {if (actif) setEtat({tiersId, erreur:true});});
    return () => {actif = false;};
  }, [tiersId, revision, autorise]);
  if (!autorise) return null;
  const connu = etat?.tiersId === tiersId && Number.isFinite(etat?.solde) && !etat.erreur;
  return <div className="border border-amber-200 bg-amber-50 p-3 text-sm" data-testid="retrait-situation-client">
    <b>Compte monétaire du client</b>
    <p>{!tiersId ? 'Contact non identifié : vérifier le compte tiers avant remise.' : !connu ? 'Solde non disponible : consulter le compte tiers avant remise.' : etat.solde < -0.001 ? `Reste dû à l’huilerie : ${fmt(-etat.solde, 3)} TND. Vérifier le règlement avec la caisse.` : etat.solde > 0.001 ? `Avance / crédit en faveur du client : ${fmt(etat.solde, 3)} TND.` : 'Solde du compte : 0 TND.'}</p>
    <p className="text-xs">Solde global consultatif, distinct du solde d’huile en kg. Actualiser après un paiement.</p>
    {tiersId && <button type="button" onClick={() => setRevision(n=>n+1)} className="mt-1 underline">Actualiser le solde</button>}
  </div>;
};
